<template>
	<div class="default">
		<ShHeaderComp />

		<slot />

		<FooterSectionComp />

		<ClientOnly>
			<LazyCookiePopup v-if="dPopup" @submit="handleSubmitCookie" />
		</ClientOnly>
	</div>
</template>

<script setup lang="ts">
const ShHeaderComp = defineAsyncComponent(
	() => import('@/components/ShHeader.vue')
);

const FooterSectionComp = defineAsyncComponent(
	() => import('@/components/FooterSection.vue')
);

const { isSubmitted, submit } = useCookieApprove();

const dPopup = ref(false);

onMounted(() => {
	dPopup.value = !isSubmitted();
});

function handleSubmitCookie() {
	submit();
	dPopup.value = !isSubmitted();
}
</script>

<style lang="scss" scoped>
.default {
	width: 100%;
	height: 100%;
}
</style>
